<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :hover="false"
                   :cols="cols"
                   :rows="correspondence"
                   :items-per-page="itemsPerPage"
                   columns="5"
                   grid-template-columns="minmax(auto, 30rem) auto minmax(max-content, 15rem) max-content max-content"
                   min-width="600px">
    <template slot="table-head">
      <div class="hm-table__th">{{ $t('table.correspondenceTable.date') }}</div>
      <div class="hm-table__th">{{ $t('table.correspondenceTable.label') }}</div>
      <div class="hm-table__th"></div>
      <div class="hm-table__th">{{ $t('table.correspondenceTable.user') }}</div>
      <div class="hm-table__th"></div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="row in slotProps.currentPage">
        <div class="hm-table__td">{{ row.creationDate | toLocalDateTime }}</div>
        <div v-tooltip="{ title: row.fileName, delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }" :class="[{'hm-table__td--clickable': isValidReference(row.referenceId)}]" class="hm-table__td privacy--blur" @click="openReference(row.referenceId, row.fileURL)">{{ row.fileName }}</div>
        <div :class="[{'hm-table__td--clickable': isValidReference(row.referenceId)}]"
             class="hm-table__td"
             @click="openReference(row.referenceId)">
          <template v-if="isValidReference(row.referenceId)">
            {{ $t(`email.title.${getReferenceType(row.referenceId)}`, [id2number(row.referenceId)]) }}
          </template>
        </div>
        <div class="hm-table__td privacy--blur">{{ row.userName }}</div>
        <div v-if="isLog(row)" class="hm-table__td hm-table__td--icon">
          <span class="quick-action-button" @click="openUrl(row.fileURL)">
            <icon icon="transfer" />
          </span>
        </div>
        <div v-else-if="isEmail(row)" class="hm-table__td hm-table__td--icon">
          <span class="quick-action-button" @click="openUrl(row.fileURL)">
            <icon icon="html" />
          </span>
        </div>
        <div v-else-if="isDocument(row)" class="hm-table__td hm-table__td--icon">
          <span class="quick-action-button" @click="openUrl(row.fileURL)">
            <icon icon="pdf" />
          </span>
          <span v-if="!isEmpty(row.renditions)" class="quick-action-button" @click="printFile(row)">
            <icon icon="printer" />
          </span>
        </div>
        <div v-else-if="isInvoice(row)" class="hm-table__td hm-table__td--icon">
          <span class="quick-action-button" @click="openUrl(row.fileURL)">
            <icon icon="pdf" />
          </span>
          <span v-if="!isEmpty(row.renditions)" class="quick-action-button" @click="printFile(row)">
            <icon icon="printer" />
          </span>
          <!-- TODO: add Epson ePOS print variant -->
        </div>
        <div v-else-if="isOffer(row)" class="hm-table__td hm-table__td--icon">
          <span class="quick-action-button" @click="openUrl(row.fileURL)">
            <icon icon="pdf" />
          </span>
          <span v-if="!isEmpty(row.renditions)" class="quick-action-button" @click="printFile(row)">
            <icon icon="printer" />
          </span>
        </div>
        <div v-else class="hm-table__td hm-table__td--icon">
        </div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { split, endsWith, head, isNil, isEmpty, slice, last } from 'lodash';

export default {
  name: 'CorrespondenceTable',

  mixins: [HotelmeisterMixin],

  props: {
    correspondence: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
    cols: {
      type: String,
      required: false,
      default: '12',
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
  },

  methods: {
    printFile(file) {
      if (isNil(file)) return;
      const fileUrl = this.getFilePrintUrl(file);
      if (isEmpty(fileUrl)) return;
      this.$serviceBus.$emit('printPDF', fileUrl);
    },
    getFilePrintUrl(file) {
      if (isEmpty(this.hotelSettings.details.stationery)) {
        return file.fileURL;
      } else {
        const printRendition = file.renditions.find(it => it.renditionIdentifier === 'INVOICE_PRINT_VERSION'
          || it.renditionIdentifier === 'OFFER_PRINT_VERSION' || it.renditionIdentifier === 'DOCUMENT_PRINT_VERSION');

        return isNil(printRendition) ? null : printRendition.fileURL;
      }
    },
    isEmail(row) {
      return row.metadata.DOCUMENT_TYPE === 'Email'
        || row.metadata.MEDIA_TYPE === 'Email'
        || row.metadata.DOCUMENT_TYPE === 'ReservationConfirmation'
        || row.metadata.DOCUMENT_TYPE === 'PaymentConfirmation';
    },
    isLog(row) {
      return row.bucket === 'Logs';
    },
    isInvoice(row) {
      return row.metadata.DOCUMENT_TYPE === 'Invoice';
    },
    isOffer(row) {
      return row.metadata.DOCUMENT_TYPE === 'Offer';
    },
    isDocument(row) {
      return row.metadata.DOCUMENT_TYPE === 'Document';
    },
    isValidReference(referenceId) {
      if (isEmpty(referenceId)) {
        return false;
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::res::[0-9]+$/gi))) {
        return true;
      } else if (!isEmpty(referenceId.match(/^tenant::[0-9]+::guest::[0-9]+$/gi))) {
        return true;
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::offer::[0-9]+$/gi))) {
        return true;
      } else if (referenceId.length === 8 && !referenceId.includes('::')) {
        return true;
      } else {
        return false;
      }
    },
    getReferenceType(referenceId) {
      if (isEmpty(referenceId)) {
        return null;
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::res::[0-9]+$/gi))) {
        return 'reservation';
      } else if (!isEmpty(referenceId.match(/^tenant::[0-9]+::guest::[0-9]+$/gi))) {
        return 'guest';
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::offer::[0-9]+$/gi))) {
        return 'offer';
      } else if (referenceId.length === 8 && !referenceId.includes('::')) {
        return 'reservationGroup';
      } else {
        return null;
      }
    },
    openReference(referenceId, fileURL) {
      if (isEmpty(referenceId)) {
        if (!isEmpty(fileURL)) this.openUrl(fileURL);
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::res::[0-9]+$/gi))) {
        this.$router.push({ name: 'reservation', params: { reservationId: referenceId } }).catch((ignore) => { if (!isEmpty(fileURL)) this.openUrl(fileURL); });
      } else if (!isEmpty(referenceId.match(/^tenant::[0-9]+::guest::[0-9]+$/gi))) {
        this.$router.push({ name: 'guest', params: { guestProfileId: referenceId } }).catch((ignore) => { if (!isEmpty(fileURL)) this.openUrl(fileURL); });
      } else if (!isEmpty(referenceId.match(/^hotel::[0-9]+::offer::[0-9]+$/gi))) {
        this.$router.push({ name: 'offer', params: { guestOfferId: referenceId } }).catch((ignore) => { if (!isEmpty(fileURL)) this.openUrl(fileURL); });
      } else if (referenceId.length === 8 && !referenceId.includes('::')) {
        this.$router.push({ name: 'reservationGroup', params: { confirmationNumberOrReservationGroupId: referenceId } }).catch((ignore) => { if (!isEmpty(fileURL)) this.openUrl(fileURL); });
      }
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "~styles/import";
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/CorrespondenceTable.vue